import React from 'react';
import { primaryVolumes, secondaryVolumes } from '../data/content';
type Volume = {
  tome: string;
  level: string;
  title: string;
  text: string;
};
type LineProps = {
  emoji: string;
  heading: string;
  volumes: Volume[];
};
function VolumeLine({
  emoji,
  heading,
  volumes
}: LineProps) {
  return <div data-id="element-203" data-mp="put0x6pk8idh">
      <h3 className="font-display text-lg font-bold text-ink sm:text-xl" data-id="element-204" data-mp="pu9kxvjh0423">
        <span aria-hidden="true" data-id="element-205" data-mp="b6oi82qic6up">{emoji} </span>
        {heading}
      </h3>
      <ul className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-206" data-mp="b4lj8t7dn3du">
        {volumes.map(volume => <li key={`${heading}-${volume.tome}`} className="flex flex-col rounded-2xl bg-sand px-5 py-6" data-id="element-207" data-mp="25qd1h4c1taj">
            <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-208" data-mp="75w9daljs3yy">
              <span data-id="element-209" data-mp="3oe9jgbhbcttz">{volume.tome}</span>
              <span aria-hidden="true" className="text-ink/25" data-id="element-210" data-mp="3ofauwh28ric8">
                ·
              </span>
              <span className="text-ink/50" data-id="element-211" data-mp="3ctxlczrjoj42">{volume.level}</span>
            </p>
            <h4 className="mt-3 font-display text-base font-bold leading-snug text-ink" data-id="element-212" data-mp="3cw0jk72upijv">
              {volume.title}
            </h4>
            <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-213" data-mp="3lv44zhphqa1j">
              {volume.text}
            </p>
          </li>)}
      </ul>
    </div>;
}
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-214" data-mp="2u2woqidwczno">
      <div className="mx-auto max-w-5xl" data-id="element-215" data-mp="2p4bo4huqgdyp">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-216" data-mp="2p5ecai0o82ax">
          <span aria-hidden="true" data-id="element-217" data-mp="32x1d8v5k5z01">📦 </span>Contenu du pack complet — 12
          Volumes
        </h2>

        <div className="mt-12 space-y-14" data-id="element-218" data-mp="2y2x3630zxauq">
          <VolumeLine emoji="📚" heading="La Ligne Primaire (5 Tomes)" volumes={primaryVolumes} data-id="element-219" data-mp="2aexf5av2jyju" />
          <VolumeLine emoji="📐" heading="La Ligne Secondaire (7 Tomes)" volumes={secondaryVolumes} data-id="element-220" data-mp="26dlkus192p5b" />
        </div>
      </div>
    </section>;
}